AGADash.Panel = (function () {

    var updateScheduled;
    var eventsHandled = false;

    var initEvents = function () {
        // Verifica se já foram criados os eventos
        if (eventsHandled)
            return;

        $("body").on("click",
            ".aga-print",
            function (e) {
                AGADash.Panel.printPanel(e.target);
            });

        eventsHandled = true;
    };


    return {
        init: function (target) {
            if (!$(target).hasClass("aga-dash-panel"))
                $(target).append("Elemento não tem a classe \"aga-dash-panel\"");

            if ($(target).hasClass("dash-inited"))
                return;

            $(target).addClass("dash-inited");

            // Criar esqueleto 
            if (AGADash.Panel.isDetailFilter(target))
                AGADash.Repository.getPanelRender().renderDetailStruct(target);
            else {
                var root = AGADash.Panel.getPanelRoot(target);
                var options = {
                    canMinimizeOnTitle: AGADash.Panel.isTitleMinimize(root),
                    isMinimized: AGADash.Panel.isMinimized(root),
                    canRemove: AGADash.Panel.isRemovable(root),
                    canResize: AGADash.Panel.isResizable(root),
                    canSelectOtherPanel: AGADash.Panel.isSelectablePanel(root),
                    isDetailColumn: AGADash.Panel.isDetailColumn(root),
                    isFullWidth: AGADash.Panel.isFullWidth(root)
                };

                AGADash.Repository.getPanelRender().renderPortletStruct(target, options);
            }
            if (AGADash.Panel.isRequestFilter(target)) {
                AGADash.Panel.renderFromRequest(target);
            } else if (AGADash.Panel.isUserFilter(target) || AGADash.Panel.isMasterFilter(target)) {
                AGADash.Panel.renderFromUser(target);
            } else if (AGADash.Panel.isDetailFilter(target)) {
                AGADash.Panel.renderFromDetail(target);
            } else {
                // render by user
                $(target).append('data-filter deve ser "request", "user" ou "master".');
            }

            initEvents();
        },

        renderFromRequest: function (target) {
            var values = AGADash.Panel.getRequestFilterValues();
            AGADash.callService('/PanelsByContext',
                { entityHandle: values.entity },
                function (data) { AGADash.Panel.renderPanelList(target, data); },
                function (errorData) {
                    AGADash.Panel.renderAjaxError(target, errorData, 'Não foi possível obter lista de painéis.');
                }
            );
        },

        isDetailColumn: function (anyTarget) {
            var root = AGADash.Panel.getPanelRoot(anyTarget);
            var value = $(root).attr("data-detail-column");
            return (value && (value === "true" || value === true));
        },

        isSelectablePanel: function (anyTarget) {
            var root = AGADash.Panel.getPanelRoot(anyTarget);
            var x = $(root).attr("data-hide-selector");
            return !(x && (x.toLowerCase() === "true"));
        },

        renderFromDetail: function (target) {
            AGADash.Panel.loadSelectedPanel(target);
        },

        renderFromUser: function (target) {
            var renderCallback = function (data) {
                AGADash.Panel.renderPanelList(target, data);
            };

            var errorCallback = function (errorData) {
                AGADash.Panel.renderAjaxError(target, errorData, "Não foi possível obter lista de painéis.");
            }

            var panel = AGADash.Panel.getFixedPanel(target);
            if (panel) {
                AGADash.callService("/PanelsById",
                    { panelIdList: panel },
                    renderCallback,
                    errorCallback);
            } else {
                AGADash.callService("/AllPanels",
                    {},
                    renderCallback,
                    errorCallback);
            }
        },

        renderPanelTitle: function (target) {
            var root = AGADash.Panel.getPanelRoot(target);
            var title = $(root).find(".dash-title");
            var id = AGADash.Panel.getCurrentPanelId(target);

            var sel = $(root).find(".dash-panel-list > li[list-id=" + id + "] > a").first();

            $(title).empty();
            $(title).append($(sel).html());
        },

        renderPanelList: function (target, data) {

            // Verificar último
            var last = "";
            var lastExists = false;
            if (AGADash.Panel.isRequestFilter(target)) {
                var ent = AGADash.Panel.getRequestFilterValues(target).entity;
                last = AGADash.Common.getLastContextPanel(ent);
            }

            var me = AGADash.Panel.getPanelRoot(target);
            var parent = $(me).find(".dash-panel-list").first();

            var lis = [];

            for (var index = 0; index < data.length; index++) {
                var cur = data[index];
                var li = document.createElement("li");
                $(li).attr("list-id", cur.Id);
                var a = document.createElement("a");
                $(a).attr("href", " javascript:;").text(cur.Name).appendTo(li);
                lis.push(li);
                var i = document.createElement("i");
                $(i).addClass("fa " + cur.Fa).prependTo(a);
                lis.push(li);

                if (cur.Id === last)
                    lastExists = true;
            }

            $(parent).empty().prepend(lis);

            // Assinar evento
            $(parent).on("click",
                "li[list-id]",
                function (e) {
                    var newId = $(e.target).attr("list-id");
                    if (!newId)
                        newId = $(e.target).closest("li").attr("list-id");
                    AGADash.Panel.setCurrentPanelId(e.target, newId);
                    AGADash.Panel.panelChanged(e);
                });

            // Selecionar o primeiro ou o último utilizado
            if (lastExists)
                AGADash.Panel.setCurrentPanelId(target, last);
            else if (data.length > 0)
                AGADash.Panel.setCurrentPanelId(target, data[0].Id);

            AGADash.Panel.loadSelectedPanel(target);
        },

        printPanel: function (anyTarget) {
            var target = AGADash.Panel.getPanelRoot(anyTarget);
            var panelId = AGADash.Panel.getCurrentPanelId(target);
            var filters = AGADash.Panel.getCurrentFilterValues(target);
            AGADash.callPrintService({
                panel: panelId,
                filters: filters
            });
        },

        panelChanged: function (e) {
            var pnl = $(e.target).closest(".aga-dash-panel");
            if (pnl)
                AGADash.Panel.loadSelectedPanel(pnl);
        },

        getPanelRoot: function (anyTarget) {
            var target = anyTarget;
            if (!$(target).hasClass("aga-dash-panel"))
                target = $(target).closest(".aga-dash-panel");
            return target;
        },

        getCurrentPanelId: function (target) {
            var root = AGADash.Panel.getPanelRoot(target);
            return $(root).attr("data-id");
        },

        setCurrentPanelId: function (anyTarget, panelId) {
            var root = AGADash.Panel.getPanelRoot(anyTarget);
            $(root).attr("data-id", panelId);
        },

        getDataFilterAttr: function (target) {
            var filter = $(target).attr("data-filter");
            if (!filter)
                $(target).append("Atributo data-filter não definido.");

            if (filter !== "request" && filter !== "user" && filter !== "detail" && filter !== "master")
                $(target).append("Atributo data-filter inválido. Informe: request|user|detail|master");

            return filter;
        },

        getDataFilterRequired: function (anyTarget) {
            var root = AGADash.Panel.getPanelRoot(anyTarget);
            var required = $(root).attr('data-filter-required');
            if (required === "false" || required === false) {
                return false;
            }
            return true;
        },

        isRequestFilter: function (target) {
            return AGADash.Panel.getDataFilterAttr(target) === 'request';
        },

        isUserFilter: function (target) {
            return AGADash.Panel.getDataFilterAttr(target) === 'user';
        },

        isDetailFilter: function (target) {
            return AGADash.Panel.getDataFilterAttr(target) === 'detail';
        },

        isMasterFilter: function (target) {
            return AGADash.Panel.getDataFilterAttr(target) === 'master';
        },

        isMinimized: function (target) {
            var state = $(target).data("state");
            return String(state).toUpperCase() === "MINIMIZED";
        },

        isRemovable: function (target) {
            var state = $(target).data("removable");
            return String(state).toUpperCase() === "TRUE";
        },

        isResizable: function (target) {
            var state = $(target).data("resizable");
            return String(state).toUpperCase() === "TRUE";
        },

        isFullWidth: function (target) {
            return $(target).parent().hasClass("col-md-12");
        },

        toggleFullWidth: function (anyTarget) {
            var root = AGADash.Panel.getPanelRoot(anyTarget);
            var isFull = AGADash.Panel.isFullWidth(root);
            $(root).parent()
                .toggleClass("col-md-12", !isFull)
                .toggleClass("col-md-6", isFull);
            return !isFull;
        },

        isTitleMinimize: function (target) {
            var state = $(target).data("titleMinimize");
            return String(state).toUpperCase() === "TRUE";
        },

        getFixedPanel: function (target) {
            return $(target).attr('data-panel');
        },

        getCurrentFilterValues: function (target) {
            var filters = "";
            if (AGADash.Panel.isRequestFilter(target)) {
                var values = AGADash.Panel.getRequestFilterValues();
                filters += "context|" + values.entity + '|' + values.handle + '|';
            } else if (AGADash.Panel.isDetailFilter(target)) {
                filters = $(target).attr("data-filter-key");

                // Retornar os filtros do pai, se o pai não for o mesmo painel
                var parentPanel = $(target).parent().closest(".aga-dash-panel");
                if (AGADash.Panel.getCurrentPanelId(parentPanel) !== AGADash.Panel.getCurrentPanelId(target)) {
                    var additionalFilter = AGADash.Panel.getCurrentFilterValues(parentPanel);
                    filters += additionalFilter;
                }
            } else if (AGADash.Panel.isUserFilter(target)) {
                $(target).find("[filter-user-key]").each(function (idx, obj) {
                    var key = $(obj).attr("filter-user-key");
                    if (key && key.length > 0)
                        filters += key;
                });
            } else if (AGADash.Panel.isMasterFilter(target)) {
                // Verifica se tem painel master
                var masterId = $(target).attr("data-filter-master-id");
                if (typeof masterId !== "undefined") {
                    var master = AGADash.Panel.getPanelRoot($("#" + masterId).first());
                    if (master)
                        filters = AGADash.Panel.getCurrentFilterValues(master);
                }
            }

            return filters;
        },

        getRequestFilterValues: function () {
            var s = location.search;
            if (s.length > 0)
                s = s.substring(1);
            var values = s.split("&");
            var ent = "";
            var handle = "";

            for (var i = 0; i < values.length; i++) {
                values[i] = values[i].split('=');
                if (values[i][0] === "ent")
                    ent = values[i][1];
                if (values[i][0] === "handle")
                    handle = values[i][1];
            }

            return { entity: ent, handle: handle };
        },

        loadSelectedPanel: function (target) {
            var panelId = AGADash.Panel.getCurrentPanelId(target);
            if (panelId) {
                AGADash.Panel.renderPanelTitle(target);

                // se o usuário filtra
                if (AGADash.Panel.isUserFilter(target)) {
                    AGADash.Panel.clearAll(target);
                    AGADash.Filter.renderFilters(panelId, target);
                } else {
                    AGADash.Panel.updatePanel(target);
                }

                // Guardar se for de contexto
                if (AGADash.Panel.isRequestFilter(target)) {
                    var ent = AGADash.Panel.getRequestFilterValues(target).entity;
                    AGADash.Common.setLastContextPanel(ent, panelId);
                }
            }
        },

        updatePanel: function (anyTarget) {
            var target = AGADash.Panel.getPanelRoot(anyTarget);
            var panelId = AGADash.Panel.getCurrentPanelId(target);
            if (panelId) {

                // Limpar detalhes atual
                AGADash.Panel.clearDetails(target);

                // Incluir texto atualizando
                AGADash.Panel.increaseUpdate(target);

                var filters = AGADash.Panel.getCurrentFilterValues(target);
                AGADash.callService("/PanelData",
                    {
                        panel: panelId,
                        filters: filters
                    },
                    function (data) {
                        AGADash.Panel.decreaseUpdate(target);
                        //AGADash.Panel.clearDetails(target);
                        AGADash.Panel.renderPanel(target, data);
                    },
                    function (errorData) {
                        AGADash.Panel.decreaseUpdate(target);
                        AGADash.Panel.renderAjaxError(target, errorData, 'Não foi possível ler dados do painel.');
                    });

                // Atualizar painéis filhos
                AGADash.Panel.updateChildPanels(target);
            }
        },

        updateChildPanels: function (target) {
            var myId = $(target).attr("id");
            if (myId) {
                var query = '.aga-dash-panel[data-filter-master-id="' + myId + '"]';
                $(query).each(function (index, obj) {
                    AGADash.Panel.updatePanel(obj);
                });
            }
        },

        renderPanel: function (target, data) {
            var dashBody = $(target).find(".dash-body").first();
            var body = document.createElement("div");

            $(dashBody).empty().append(body);
            $(body).uniqueId();
            //$(body).uniqueId().attr("dash-type", data.PanelType);
            //$(target).attr("dash-type", data.PanelType);

            if ((data.PanelType < 900) && (data.Values == null)) {
                AGADash.Panel.renderBodyMessage(target, 'Não existem informações a exibir.');
                AGADash.Panel.setupPrinterBtn(target, false);
                AGADash.Panel.setupInfoBtn(target, data.Info);
                return;
            }

            // Mostrar ou não o botão de impressora
            AGADash.Panel.setupPrinterBtn(target, data.HasReport);

            // Mostrar ou não o botão info
            AGADash.Panel.setupInfoBtn(target, data.Info);

            // Adicionar o UID no root do panel
            $(AGADash.Panel.getPanelRoot(target)).attr("data-uid", data.UID);

            // Renderizar por tipo
            var render = AGADash.Repository.find(data.PanelType);
            if (render) {
                render.render(body, data);
            } else {
                if (data.PanelType === 901) {
                    // Exige filtro
                    AGADash.Panel.renderBodyMessage(target, "Informe um filtro.");
                    AGADash.Panel.setupPrinterBtn(target, false);
                } else {
                    AGADash.Panel.renderBodyMessage(target, "Tipo " + data.PanelType + " não suportado");
                }
            }
        },

        setupInfoBtn: function (target, infoText) {
            $(target).find(".aga-info[aria-describedby]").popover("destroy");
            if (infoText && infoText.length > 0) {
                var btn = $(target).find(".aga-info").first();
                $(btn).removeClass("hide").attr({
                    "data-container": "body",
                    "data-trigger": "click",
                    "data-placement": "bottom",
                    "data-content": infoText,
                    "data-original-title": '<h4><i class="fa fa-info"></i> Finalidade</h4>'
                }).addClass("popovers").popover({ "html": true });
            } else {
                $(target).find(".aga-info").addClass("hide");
            }
        },

        setupPrinterBtn: function (target, visible) {
            if (visible)
                $(target).find(".aga-print").removeClass("hide");
            else
                $(target).find(".aga-print").addClass("hide");
        },

        clearAll: function (anyTarget) {
            var me = AGADash.Panel.getPanelRoot(anyTarget);
            $(me).find(".dash-filters, .dash-body, .dash-footer").empty();
            AGADash.Panel.clearDetails(me);
        },

        clearDetails: function (target) {
            var placeHolder = $(AGADash.Panel.getPanelRoot(target)).find(".dash-footer").first();
            $(placeHolder).empty();
        },

        loadDetails: function (anyTarget, detailKeys) {
            var panelNode = anyTarget;
            if (!$(panelNode).hasClass("aga-dash-panel"))
                panelNode = $(panelNode).closest(".aga-dash-panel");

            var panelId = AGADash.Panel.getCurrentPanelId(panelNode);

            AGADash.callService('/PanelDetails',
                {
                    'panel': panelId,
                    'detailKeys': detailKeys
                },
                function (data) { AGADash.Panel.renderDetails(panelNode, data); },
                function (errorData) {
                    AGADash.Panel.renderAjaxError(panelNode, errorData, 'Não foi possível ler os dados dos detalhes.');
                });

        },

        getDetailPlaceHolder: function (target) {
            var placeHolder = $(target).find('.dash-footer').first();
            return placeHolder;
        },

        renderDetails: function (target, data) {

            // Limpar detalhes antes
            AGADash.Panel.clearDetails(target);

            if ((!data) || (data.length === 0))
                return;

            var placeHolder = AGADash.Panel.getDetailPlaceHolder(target);
            AGADash.Details.render(placeHolder, data);
        },

        renderBodyMessage: function (anyTarget, message) {
            var body;
            if ($(anyTarget).hasClass('aga-dash-panel'))
                body = $(anyTarget).find('.dash-body').first();
            else
                body = $(anyTarget).closest('.aga-dash-panel').find('.dash-body').first();
            body.empty().append('<h2>' + message + '</h2>');
        },

        scheduleUpdate: function (anyTarget) {

            AGADash.Panel.cancelSchedule();

            updateScheduled = setTimeout(function () {
                updateScheduled = null;
                AGADash.Panel.updatePanel(anyTarget);
            },
                1000);
        },

        cancelSchedule: function () {
            if (updateScheduled && updateScheduled != null)
                clearTimeout(updateScheduled);
            updateScheduled = null;
        },

        renderAjaxError: function (anyTarget, data, defaultMessage) {
            var root = AGADash.Panel.getPanelRoot(anyTarget);
            AGADash.Panel.clearDetails(root);

            var placeHolder = AGADash.Panel.getDetailPlaceHolder(root);

            // Problema de login?
            if ((data.responseText.indexOf('wesLogin_titlePage') > 0) && (data.responseText.indexOf('"login"') > 0)) {
                $(placeHolder)
                    .append('<a href="' + AGADash.appUrl() + '" >Clique aqui para fazer o login novamente</a>');
                return;
            }

            var msgErro = data.responseText;
            if (data.responseJSON && data.responseJSON.ExceptionMessage)
                msgErro = data.responseJSON.ExceptionMessage;

            var msgEle = document.createElement("p");
            $(msgEle).css("color", "red").text(defaultMessage + "   ").appendTo(placeHolder);
            var seeError = document.createElement("a");
            $(seeError).attr("href", "javascript:AGADash.Panel.showError();").text("Ver erro").appendTo(placeHolder);
            var errorP = document.createElement("p");
            $(errorP).addClass("hide dash-error").text(msgErro).appendTo(placeHolder);
        },

        showError: function () {
            $(".dash-error").toggleClass("hide");
        },

        increaseUpdate: function (target) {
            AGADash.Panel.deltaUpdate(target, 1);
        },

        decreaseUpdate: function (target) {
            AGADash.Panel.deltaUpdate(target, -1);
        },

        deltaUpdate: function (target, delta) {
            var pnl = $(target).find(".dash-updating").first();
            if (pnl) {
                var atual = parseInt($(pnl).attr("count"));
                atual += delta;
                $(pnl).attr("count", atual);
            }
        },

        remove: function (anyTarget) {
            var root = AGADash.Panel.getPanelRoot(anyTarget);
            var plcClass = "dash-placeholder";
            if ($(root).parent().hasClass(plcClass))
                $(root).parent().detach();
            else
                $(root).detach();
        }
    };

})();